import React from 'react';
import { CMSContent } from '../components/data/CMSContent';

export const PrivacyNoticePage = props => {
  return <CMSContent type={'contentitem'} name={'privacy-policy'} />;
};
